<template>
  <div class="page">
    <div class="m-model-wrap">
      <div
        class="m-model"
        v-if="model === 'full'"
      >
        <div class="m-model-exmp">
          <div class="u-left">
            <div class="u-top"></div>
            <div class="u-bottom"></div>
          </div>
          <div class="u-right"></div>
        </div>
        <span class="u-model-name">{{ $t("management.home.full_type") }}</span>
      </div>
      <div
        class="m-model"
        v-if="model === 'limit'"
      >
        <div class="m-model-exmp">
          <div class="u-mid"></div>
        </div>
        <span class="u-model-name">{{ $t("management.home.limit_type") }}</span>
      </div>
      <div>
        <el-button
          type="primary"
          @click="handleGoIn"
        >{{
          $t("management.home.go_to_update")
          }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Api from 'api/api'
export default {
  data () {
    return {
      model: 'full'
    }
  },
  mounted () {
    this.getCurrentLayoutType()
  },
  methods: {
    handleGoIn () {
      let baseUrl = process.env.NODE_ENV === 'development' ? '' : `${process.env.VUE_APP_CONTEXT}`
      window.open(`${baseUrl}/management/home-configuration?branch=full`)
    },
    // 获取当前首页类型
    getCurrentLayoutType () {
      Api.homeConfig.getCurrentLayoutType().then(res => {
        this.model = res.data ? 'limit' : 'full'
      }).catch(err => {
        this.$message.error(err.msg)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  position: relative;
  width: 100%;
  height: 100%;
  .m-model-wrap {
    position: absolute;
    top: 50%;
    margin-top: -220px;
    width: 100%;
    height: 440px;
    text-align: center;
    .m-model {
      display: inline-block;
      width: 318px;
      height: 208px;
      margin: 60px 40px;
      // cursor: pointer;
      .m-model-exmp {
        width: 100%;
        height: 166px;
        padding: 4px;
        box-sizing: border-box;
        border: 1px solid #e0e0e0;
        .u-left {
          width: 222px;
          height: 100%;
          float: left;
          .u-top {
            width: 100%;
            height: 62px;
            background: rgba(30, 127, 255, 0.08);
          }
          .u-bottom {
            width: 100%;
            height: calc(~"100% - 66px");
            margin-top: 4px;
            background: rgba(30, 127, 255, 0.08);
          }
        }
        .u-right {
          float: right;
          width: 82px;
          height: 100%;
          background: rgba(30, 127, 255, 0.08);
        }
        .u-mid {
          width: 192px;
          height: 100%;
          margin: 0 auto;
          background: rgba(30, 127, 255, 0.08);
        }
      }
      // .m-model-exmp:hover {
      //   box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
      // }
    }
    .u-model-name {
      display: block;
      line-height: 18px;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.7);
      margin-top: 24px;
    }
  }
}
</style>
